module.exports = __webpack_public_path__ + "img/new-into-the-jungle-trailer.7aaccda5.jpg";